/**
 * @generated SignedSource<<036c86a0b076341fab3ced6f3a89e6a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type FlightDirection = "FORWARD" | "RETURN";
export type FlightProvider = "KIWI" | "WAAVO";
import { FragmentRefs } from "relay-runtime";
export type FlightSearchResult_makeFlightInput$data = {
  readonly bookingToken: string | null;
  readonly forwardSegments: ReadonlyArray<{
    readonly arrivalAirportCode: string;
    readonly arrivalCity: string | null;
    readonly arrivalDatetime: string;
    readonly carrier: string | null;
    readonly departAirportCode: string;
    readonly departCity: string | null;
    readonly departDatetime: string;
    readonly direction: FlightDirection | null;
    readonly duration: string;
    readonly flightNumber: string;
    readonly price: number | null;
    readonly supplier: string;
  }>;
  readonly priceKey: string;
  readonly priceLive: number;
  readonly priceSupplier: number;
  readonly provider: FlightProvider;
  readonly returnSegments: ReadonlyArray<{
    readonly arrivalAirportCode: string;
    readonly arrivalCity: string | null;
    readonly arrivalDatetime: string;
    readonly carrier: string | null;
    readonly departAirportCode: string;
    readonly departCity: string | null;
    readonly departDatetime: string;
    readonly direction: FlightDirection | null;
    readonly duration: string;
    readonly flightNumber: string;
    readonly price: number | null;
    readonly supplier: string;
  }>;
  readonly supplier: string;
  readonly " $fragmentType": "FlightSearchResult_makeFlightInput";
};
export type FlightSearchResult_makeFlightInput$key = {
  readonly " $data"?: FlightSearchResult_makeFlightInput$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSearchResult_makeFlightInput">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "FlightSearchResult_makeFlightInput"
};

(node as any).hash = "e07bbc368da5b86ca52a801b38faaf61";

export default node;
